import styled from "styled-components";

export const WrapperContentLeft = styled.div`
    flex: 1;
    padding: 40px 45px 24px;
    display: flex;
    flex-direction: column;
    gap: 20px;

    @media (max-width: 768px) {
        padding: 24px 20px;
    }
`

export const WrapperContentRight = styled.div`
    width: 300px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    background-color: rgba(0,0,0,.12);

    @media (max-width: 768px) {
        width: 100%;
        padding: 20px 16px;
    }
`

export const WrapperTextLink = styled.span`
    color: rgb(13,92,182);
    font-size: 13px;
`
